import { ChangeDetectionStrategy, Component, computed, OnInit, inject } from '@angular/core';
import { IrisDmsFoldersSandbox } from '../../../sandbox/dms-folders.sandbox';
import { IrisDmsGlobalSandbox } from '../../../sandbox/dms-global.sandbox';
import { IrisGlobalSandbox } from '@iris/common/redux/global.sandbox';
import { TranslatePipe } from '@ngx-translate/core';
import { IrisDmsMatFoldersTreeComponent } from '../../folders-structures/dms-mat-folders-tree/dms-mat-folders-tree.component';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';
import {
  ConfirmByKeypressDirective,
  SkModalBase,
  SkModalContentComponent,
  StrakitButtonPrefixDirective,
} from '@ngx-strakit/cdk';

@Component({
  selector: 'iris-move-entities-modal',
  imports: [
    TranslatePipe,

    IrisDmsMatFoldersTreeComponent,

    ConfirmByKeypressDirective,
    SkModalContentComponent,
    StrakitButtonComponent,
    StrakitButtonPrefixDirective,
  ],
  templateUrl: './move-entities-modal.component.html',
  styleUrls: ['./move-entities-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisMoveEntitiesModalComponent extends SkModalBase<IrisMoveEntitiesModalComponent, { targetFolderId: string; selectTargetFolder: boolean }> implements OnInit {
  private readonly dmsFoldersSandbox = inject(IrisDmsFoldersSandbox);
  private readonly dmsGlobalSandbox = inject(IrisDmsGlobalSandbox);
  private readonly globalSnadbox = inject(IrisGlobalSandbox);

  label = 'label.Move';

  readonly projectInfoMessage = computed(() => {
    const projectId = this.dmsGlobalSandbox.currentProjectIdModal();
    return !projectId ? 'text.dms.PleaseSelectProject' : 'text.dms.ThisProjectDoNotHaveFolders';
  });

  readonly selectedFolderId = this.dmsFoldersSandbox.selectedFolderIdModal;
  readonly showFoldersTree = computed(() => !!this.dmsFoldersSandbox.currentProjectRootFolder()?.projectId);
  readonly submitDisabled = computed(() => !this.selectedFolderId());

  ngOnInit(): void {
    this.dmsFoldersSandbox.changeProjectFolderModal(this.globalSnadbox.currentProjectId());
    this.fetchProjectRootFolder();
  }

  confirmSelection(selectTargetFolder = false): void {
    if (this.submitDisabled()) { return; }
    this.closeWithResult({ targetFolderId: this.selectedFolderId(), selectTargetFolder });
    this.dmsFoldersSandbox.resetSelectedFoldersListModal();
  }

  private fetchProjectRootFolder(): void {
    const currentProjectId = this.dmsGlobalSandbox.currentProjectIdModal();
    const rootFolder = this.dmsFoldersSandbox.currentProjectRootFolder();

    if (!!currentProjectId && !rootFolder) {
      this.dmsFoldersSandbox.getProjectRootFolder(currentProjectId);
    }
  }
}
